import { render } from "./CardsWithAmountChart.vue?vue&type=template&id=8cd6bbdc&ts=true"
import script from "./CardsWithAmountChart.vue?vue&type=script&lang=ts"
export * from "./CardsWithAmountChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__